import { Component, HostListener, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';

import { ContextMenuConfiguration, ContextMenuItem, ContextMenuRequest } from '../../models';
import { ContextMenuService } from '../../services';
import { NgStyle } from '@angular/common';
import { SvgIconComponent } from 'angular-svg-icon';


@Component({
    selector: 'lib-context-menu',
    templateUrl: './context-menu.component.html',
    styleUrls: ['./context-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgStyle, SvgIconComponent]
})
export class ContextMenuComponent implements OnInit, OnDestroy {
  private _subscriptions: Subscription = new Subscription();
  private _configurations: ContextMenuConfiguration[] = [];

  public items: ContextMenuItem[] = [];
  public xPosition: number = 0;
  public yPosition: number = 0;

  constructor(
    private _contextMenuService: ContextMenuService
  ) { }

  public ngOnInit(): void {
    this._subscriptions.add(
      this._contextMenuService.contextMenuRegistered$.subscribe(configuration => {
        this.removeRegistration(configuration.uniqueName);
        this._configurations.push(configuration);
      })
    );

    this._subscriptions.add(
      this._contextMenuService.contextMenuRemoved$.subscribe(uniqueName => this.removeRegistration(uniqueName))
    );

    this._subscriptions.add(
      this._contextMenuService.contextMenuRequested$.subscribe(request => this.openContextMenu(request))
    );
  }

  public ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  @HostListener('document:click', ['$event'])
  public onLeftClick(_: PointerEvent): void {
    if (!this.items || this.items.length === 0) {
      return;
    }

    this.items = [];
  }

  public onClickedItem(item: ContextMenuItem): void {
    if (item.isDisabled) {
      return;
    }

    item.clicked.next(null);
  }

  private removeRegistration(uniqueName: string): void {
    const index = this._configurations.findIndex(c => c.uniqueName === uniqueName);
    if (index < 0) {
      return;
    }

    this._configurations.splice(index, 1);
  }

  private openContextMenu(request: ContextMenuRequest): void {
    this.items = [];

    const configuration = this._configurations.find(c => c.uniqueName === request.uniqueName);
    if (!configuration) {
      return;
    }

    this.xPosition = request.xPosition;
    this.yPosition = request.yPosition;

    const items: ContextMenuItem[] = [];
    for (const item of configuration.items) {
      if (item.isHidden) {
        continue;
      }

      if (item.isSeparator && items.length === 0) {
        continue;
      }

      if (item.isSeparator && items.length > 0 && items[items.length - 1].isSeparator) {
        continue;
      }

      items.push(item);
    }

    if (items.length === 0) {
      return;
    }

    if (items[items.length - 1].isSeparator) {
      items.splice(items.length - 1, 1);
    }

    const height = items.length * 37;

    if (this.yPosition + height > document.body.clientHeight) {
      this.yPosition -= height;
    }

    if (this.xPosition + 252 > document.body.clientWidth) {
      this.xPosition -= 252;
    }

    this.items = items;
  }
}
